import { requests } from '.'
import servicesConfig from '../config/services'
import { FetchRecentlyViewed } from '../types/recently-viewed'

interface onboardingTagTaskSchedulerBody {
  companyId: string
}

const OnboardingService = {
  createTosLogs: (body: any) =>
    requests(servicesConfig.Onboarding).post('/tos', body),
  recentlyViewed: (params: FetchRecentlyViewed) =>
    requests(servicesConfig.Onboarding).get(`${params.locationId}/recentvisited?skip=${params.skip}&limit=${params.limit}`),
  verifyStatus: (companyId: string) =>
    requests(servicesConfig.Onboarding).get(`/verify/status?companyId=${companyId}`),
  onboardingTagTaskScheduler: (body: onboardingTagTaskSchedulerBody) =>
    requests(servicesConfig.Onboarding).post('/tags/task-scheduler', body),
}

export default OnboardingService
